module.exports = __webpack_public_path__ + "img/cat-in-the-box.8b069911.png";